import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AnalyseResult = ({ children, legend, ...rest })=>/*#__PURE__*/ _jsxs("ul", {
        className: "rtg-analyse-result",
        ...rest,
        children: [
            !!legend && /*#__PURE__*/ _jsx("li", {
                className: "rtg-legend",
                children: legend
            }),
            children
        ]
    });
export { AnalyseResult };
